
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
}

/**
 * 手机号校验
 */
export const checkPhone = telNum => {

}

// export default {
//   setStore,
//   getStore,
//   removeStore,
//   checkPhone
// }


export const formatime = function (value, fmt) {
  let time = value;
  let getDate = new Date(time);
  let o = {
    'M+': getDate.getMonth() + 1,
    'd+': getDate.getDate(),
    'h+': getDate.getHours(),
    'm+': getDate.getMinutes(),
    's+': getDate.getSeconds(),
    'q+': Math.floor((getDate.getMonth() + 3) / 3),
    'S': getDate.getMilliseconds()
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt;
};

export const formatUtc = function (time, format) {
  var date = new Date(time);
  var formatter = function (i) { return (i < 10 ? '0' : '') + i };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
    switch (a) {
      case 'yyyy':
        return formatter(date.getFullYear());
        break;
      case 'MM':
        return formatter(date.getMonth() + 1);
        break;
      case 'mm':
        return formatter(date.getMinutes());
        break;
      case 'dd':
        return formatter(date.getDate());
        break;
      case 'HH':
        return formatter(date.getHours());
        break;
      case 'ss':
        return formatter(date.getSeconds());
        break;
    }
  })
}



// WEBPACK FOOTER //
// ./src/until/until.js